export default __webpack_public_path__ + "static/media/image_topic-risks.5e6a4d9d.svg";